import MetaHeader from '../components/common/MetaHeader';
import ALink from '../components/common/ALink';

export default function PrivacyPolicy() {
  return (
    <>
    <MetaHeader title={'Privacy Policy'}/>
    <main className="main">
      <nav aria-label="breadcrumb" className="breadcrumb-nav mb-0">
        <div className="container">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <ALink href="/">Home</ALink>
            </li>
            <li className="breadcrumb-item">
              <ALink href="#">Pages</ALink>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Privacy & Policy
            </li>
          </ol>
        </div>
      </nav>

      <div className="container">
        <div className="subpage">
          <h1 className="subpage__title">Privacy & Policy</h1>
          <div className="subpage__section">
            <p className="subpage__paragraph">
              You linked to this Privacy Policy (“Privacy Policy”) via a product
              website owned by Dorado Management LLC (“Company”, “us”, “our” or
              “we”). The Company’s website includes buyontrust.com (the
              “Website”). By the Website, you signify that you have read,
              understand and agree to be bound by this Privacy Policy.
            </p>
            <br></br>
            <p className="subpage__paragraph">
              This Privacy Policy applies to all online communication with the
              Website owned by the Company but does not apply to our data
              collection activities offline unless we otherwise indicate at the
              time of collection. It is important for you to understand what
              information we collect about you during your visit to our Website
              and what we do with that information. Please note that your visit
              the Website is subject to this Privacy Policy and our Terms of
              Service. By using the Website, you consent and agree to our
              Privacy Policy and Terms of Service and our collection, use and
              sharing of your information and data, and other activities, as
              described below. If you do not agree to the terms of this Privacy
              Policy, please do not provide us with any personal information and
              do not use our Website.
            </p>
          </div>

          <div className="subpage__section">
            <ol className="subpage__list--ordered bold">
              <li>
                <b>Information Collection</b>
                <p className="subpage__paragraph">
                  We collect personally identifiable information about you via
                  the Website when you provide it through various forms and
                  places on the Website such as in connection with a request or
                  purchase of a product, service, or information or if you
                  register for a Website account. You may browse our Website
                  without providing any personal information; however if, for
                  example, you decide to place an order, we will ask you for
                  your name, delivery and billing address, phone number(s),
                  email address, financial background questions (income history,
                  monthly income, checking account details, and checking
                  activity) and payment information such as credit/debit card
                  number, expiration dates, third party payment information. If
                  you choose to complete a user registration form, survey, we
                  may ask you for personal information, such as your contact
                  information (e.g., name, e-mail address and mailing address).
                  Occasionally, we may also ask you for other demographic
                  information, such as gender, income level, and information
                  about your prior experiences with the Company’s products. If
                  we combine demographic information with the personal
                  information we collect directly from you on our Website, we
                  will treat the combined data as personal information under
                  this Privacy Policy. When you submit your personally
                  identifiable or demographic information, you are giving your
                  consent to the collection, use and disclosure of your
                  information as set forth in this Privacy Policy.
                </p>
                <br></br>
                <p className="subpage__paragraph">
                  We may also use the tracking technologies described in Section
                  5 below in order to automatically (or passively) collect,
                  store or accumulate certain non-personally identifiable
                  information concerning your use of this Website, such as
                  information regarding which of our pages are most popular and
                  remembering you and your preferences, your IP address, UDID or
                  other unique identifier, device functionality (including
                  browser, operator system, hardware, mobile network
                  information), device location, device characteristics, city,
                  time zone, and referring URL. Information gathered may be used
                  in aggregate form for internal business purposes, such as
                  generating statistics, developing marketing plans, customizing
                  content, and improving the Website. This usage information may
                  be stored or accessed using a variety of technologies that may
                  be downloaded to your personal computer, browser, laptop,
                  tablet, mobile phone or other device whenever you visit or
                  interact with our Site. We may share or transfer such
                  aggregate, non-personally identifiable information with or to
                  our affiliates, licensees, partners and other third parties.
                </p>
                <br></br>
                <p className="subpage__paragraph">
                  We may combine automatically collected Website usage
                  information with your Personal Information. In those cases, we
                  will apply this Privacy Policy to the combined information.
                </p>
                <br></br>
                <p className="subpage__paragraph">
                  The Website is intended for a general audience. We do not
                  knowingly collect personal information from children under the
                  age of 13. We will delete any personal information collected
                  that we later determine to be from a user younger than the age
                  of 13. If you are a parent or guardian of a child under the
                  age of 13 and believe he or she has disclosed personal
                  information to us, please contact Customer Service using the
                  contact information below.
                </p>
              </li>
              <li>
                <b>Use/Disclosure of Personal Information</b>
                <p>
                  The Company and its affiliates and subsidiaries may use your
                  information as follows:
                </p>
                <ul className="subpage__list">
                  <li>
                    To place an order made through the Website and fulfill your
                    order request;
                  </li>
                  <li>
                    To notify you of product recalls or providing other
                    information concerning products you have purchased;
                  </li>
                  <li>
                    To improve merchandise selections and the overall shopping
                    experience at the Website;
                  </li>
                  <li>
                    To process transactions or provide you with information such
                    as to send you electronic newsletters or to provide you with
                    special offers or promotional and marketing materials on
                    behalf of us or third parties, including to let you know
                    about new products, services or upcoming events;
                  </li>
                  <li>
                    To improve the Website, marketing endeavors or our Website
                    offerings;
                  </li>
                  <li>
                    To customize your experience on the Website or to serve you
                    specific content or ads that are relevant to you;
                  </li>
                  <li>to provide customer support;</li>
                  <li>
                    To contact you with regard to your use of the Website and,
                    in our discretion, changes to the Website and/or Website’s
                    policies;
                  </li>
                  <li>
                    To identify your product and Website preferences so that you
                    can be informed of new or additional products, services and
                    promotions;
                  </li>
                  <li>
                    To enable you to participate in a variety of the Website’s
                    features such as to enable you to participate in online
                    entry sweepstakes, contests or other promotions;
                  </li>
                  <li>To improve the overall experience at the Website;</li>
                  <li>For internal business purposes; </li>
                  <li>
                    For purposes disclosed at the time you provide your
                    information or as otherwise set forth in this Privacy
                    Policy.
                  </li>
                </ul>
                <br></br>
                <p className="subpage__paragraph">
                  We use the Personal Information that you supply to personalize
                  your experience with the us. In connection with the foregoing,
                  we may transfer your Personal Information to certain Third
                  Party Service Providers. You agree that we may contact you at
                  any time with updates and/or any other information that we may
                  deem appropriate for you to receive in connection with your
                  continued request for Third Party Services.
                </p>
                <br></br>
                <p className="subpage__paragraph">
                  The Personal Information that you submit to us remains your
                  property, but by submitting your Personal Information to us
                  you grant us the right, subject to applicable state and
                  federal law, to use that Personal Information for marketing
                  purposes. Without limiting the generality of the foregoing, we
                  reserve the right to share, sell, rent, lease and/or otherwise
                  distribute any and all Personal Information (other than
                  Sensitive Information) with/to any third-party for any and all
                  uses permitted by this Privacy Policy and applicable law.
                  These third-parties may include but shall not be limited to:
                  (a) providers of direct marketing services and applications,
                  including lookup and reference, data enhancement, suppression
                  and validation; (b) e-mail marketers; (c) telemarketers (where
                  permitted by applicable law); (d) SMS text-based marketers
                  (where and to the extent permitted by applicable law); and (e)
                  companies that assist with financing or product fulfillment.
                  We may also use your Personal Information (other than
                  Sensitive Information) for any marketing and survey purpose,
                  on our own behalf and on behalf of our affiliates and
                  subsidiaries.
                </p>
                <br></br>
                <p className="subpage__paragraph">
                  We may share your Personal Information with Third Party
                  Service Providers in connection with services you requested.
                  These Third Party Service Providers may use your Personal
                  Information to offer you Third Party Services, and for any
                  other lawful purposes, subject to any restrictions contained
                  herein. The information that you supply to any Third Party
                  Service Providers shall be governed by the applicable Third
                  Party Service Provider’s privacy policy. Please be advised
                  that we do not itself provide Third Party Service-related
                  products and/or services, and the ultimate terms and
                  conditions of any product or service provided by Third Party
                  Service Providers will be determined by those Third Party
                  Service Providers.
                </p>
                <br></br>
                <p className="subpage__paragraph">
                  Your Personal Information will also be shared with Third Party
                  Service Providers, advertisers and marketers on an aggregate
                  basis. Please keep in mind, though, that we do not control,
                  and is not responsible for, the practices of our advertisers,
                  marketers and/or Third Party Service Providers. If you wish to
                  stop receiving future communications from us and/or
                  third-party advertisers, or if you wish to prevent the
                  transfer and/or sale of your Personal Information to
                  third-parties (subject to restrictions contained in applicable
                  state and federal law), please see the Opt-Out/Unsubscribe
                  section below.
                </p>
                <br></br>
                <p className="subpage__paragraph">
                  By registering on the Site, you agree that such act
                  constitutes an inquiry and/or application for purposes of the
                  Amended Telemarketing Sales Rule (16 CFR §310 et seq.), as
                  amended from time to time (the “Rule”) and applicable state
                  do-not-call regulations. As such, notwithstanding that your
                  telephone number may be listed on the Federal Trade
                  Commission’s Do-Not-Call List, and/or on applicable state
                  do-not-call lists, we retain the right to contact you via
                  telemarketing (where you supply your telephone number to us)
                  in accordance with the Rule and applicable state do-not-call
                  regulations.
                </p>
                <br></br>
                <p className="subpage__paragraph">
                  In addition, where you provide “prior express written consent”
                  within the meaning of the Telephone Consumer Protection Act
                  (47 USC § 227), and its implementing regulations adopted by
                  the Federal Communications Commission (47 CFR § 64.1200), as
                  amended from time-to-time (“TCPA”), you consent to receive
                  telephone calls, including artificial voice calls,
                  pre-recorded messages and/or calls (including SMS text
                  messages) delivered via automated technology, to the telephone
                  number(s) that you provided. Please note that you are not
                  required to provide this consent in order to receive Third
                  Party Services, and your consent simply allows us and our
                  third party marketing partners and/or Third Party Service
                  Providers, as applicable, to contact you via these means.
                </p>
                <br></br>
                <p className="subpage__paragraph">
                  We reserve the right to release current or past Personal
                  Information: (i) in the event that we believe that the our
                  offerings are being, or have been, used in violation of the
                  Terms of Service or to commit unlawful acts; (ii) if the
                  information is subpoenaed; provided, however, that, where
                  permitted by applicable law, we shall provide you with e-mail
                  notice, and opportunity to challenge the subpoena, prior to
                  disclosure of any Personal Information pursuant to a subpoena;
                  or (iii) if we are sold, merge with a third party or are
                  acquired; provided, however, that if we are involved in a
                  merger, acquisition or sale of all or a portion of its assets,
                  you will be notified via email and/or a prominent notice on
                  the Site of any change in ownership or uses of your Personal
                  Information, as well as any choices that you may have
                  regarding your Personal Information. Moreover, you hereby
                  consent to disclosure of any record or communication to any
                  third-party when we, in our sole discretion, determines the
                  disclosure to be appropriate including, without limitation,
                  sharing your e-mail address with other third-parties for
                  suppression purposes in compliance with the CAN-SPAM Act of
                  2003, as amended from time to time.
                </p>
                <br></br>
                <p className="subpage__paragraph">
                  If for any reason you would no longer like to receive email
                  marketing messages from the Company, you may follow the
                  instructions contained within our promotional emails or please
                  click here. Please allow up to ten (10) days for us to process
                  your request. This will not affect subsequent subscriptions
                  and if your opt-out is limited to certain types or categories
                  of emails the opt-out will be so limited. Please note, if you
                  opt not to receive marketing emails from the Company, you may
                  still receive “transactional” email messages regarding your
                  account, use of the Website or your order (e.g., order
                  confirmation, shipping information, recall notices, customer
                  service notifications, etc.). If you have questions or
                  concerns regarding this statement, please contact Customer
                  Service.
                </p>
                <br></br>
                <p className="subpage__paragraph">
                  The Company may share non-personal information, such as
                  aggregated user statistics, with third parties. The Company
                  may also share and sell your information, such as your name,
                  email address, mailing address and/or telephone number to
                  business partners, vendors and other third party organizations
                  to provide you with information about products, services and
                  special offers we think may interest you or to improve our
                  products, services and advertising. If you are a California
                  resident, you have the right to request additional information
                  about this sharing, so please see Section 12 below. In
                  addition, we may share the information we have collected about
                  you, including personal information, as disclosed at the time
                  you provide your information and as described below or
                  otherwise in this Privacy Policy.
                </p>
                <br></br>
                <p className="subpage__paragraph">
                  We may contract with companies or individuals to provide
                  certain services including email and hosting services, credit
                  card processing, shipping, data management, surveys and
                  marketing, promotional services, to assist in preventing or
                  deterring fraud, etc. We call them our “Service Providers”. We
                  may share personally identifiable information with Service
                  Providers solely as appropriate for them to perform their
                  functions, but they may not use such information for any other
                  purpose.
                </p>
                <br></br>
                <p className="subpage__paragraph">
                  We do not share your credit card information with unaffiliated
                  third parties unless you authorize us to do so, or if it is
                  necessary to fulfill our responsibilities, including, but not
                  limited to, delivering a product or service that you order.
                </p>
                <br></br>
                <p className="subpage__paragraph">
                  Some of our pages utilize framing techniques to serve content
                  to/from our partners while preserving the look and feel of our
                  Website. Please be aware that you are providing your personal
                  information to these third parties and not to Company.
                </p>
                <br></br>
                <p className="subpage__paragraph">
                  The Company may, in its sole discretion, disclose personal
                  information in special cases: (1) when we have reason to
                  believe that disclosing this information is necessary to
                  identify, contact, or bring legal action against someone who
                  may be causing injury to or interference with (either
                  intentionally or unintentionally) the rights of the Company or
                  to anyone that could be harmed by such activities; (2) when we
                  believe in good faith that the law requires it; (3) to a
                  subsequent owner, co-owner or operator of a Website or
                  applicable database or in connection with a merger,
                  consolidation, restructuring, the sale of substantially all of
                  our interests and/or assets or other corporate change,
                  including, during the course of any due diligence process; and
                  (4) in situations involving threats to the physical safety of
                  any person.
                </p>
                <br></br>
              </li>
              <li>
                <b>Information Security</b>
                <p className="subpage__paragraph">
                  We use Secure Sockets Layer (SSL), an advanced security
                  protocol that protects your credit card information and
                  ensures secure online ordering. SSL Internet connections are
                  encrypted, and thus protect all credit card ordering
                  information, including your name, address and credit card
                  number, so it cannot be read in transit. We use secure
                  technology, privacy protection controls, and restrictions on
                  employee access, to safeguard your personal information.
                  Please note, however, that although we employ
                  industry-standard security measures to safeguard the security
                  of your personal information, no transmissions made on or
                  through the Internet are guaranteed to be secure. Please note
                  that we cannot ensure the security of any information you
                  transmit to us, and you use our Website and provide us with
                  your information at your own risk.
                </p>
              </li>
              <li>
                <b>Access and Choice</b>
                <p className="subpage__paragraph">
                  If your personal information changes, or if you no longer
                  desire our service, you may correct, update, amend,
                  delete/remove, or deactivate it by making the change on our
                  member information page or by emailing our Customer Support at
                  info@buyontrust.com or by contacting us by telephone or postal
                  mail at the contact information listed below. We will respond
                  to your request within a reasonable timeframe.
                </p>
              </li>
              <li>
                <b>Technology Utilized / Tracking Technologies</b>
                <p className="subpage__paragraph">
                  We and our marketing partners, affiliates, or analytics or
                  service providers, use technologies such as cookies, beacons,
                  tags, browser fingerprinting, recognition technologies and
                  scripts, to analyze trends, administer the Website, tracking
                  users’ movements around the Website, and to gather demographic
                  information about our user base as a whole. We may receive
                  reports based on the use of these technologies by these
                  companies on an individual and aggregated basis.
                </p>
                <br></br>
                <p className="subpage__paragraph">
                  There may be other tracking technologies now and later devised
                  and used by us in connection with the Website. Further, third
                  parties may use tracking technologies in connection with our
                  Website, which may include the collection and storing of
                  information about your online activities over time and across
                  third-party websites or online services.
                </p>
                <br></br>
                <p className="subpage__paragraph">
                  We and third-party vendors, including Google, use first-party
                  cookies and third-party cookies together to report how your ad
                  impressions, other uses of ad services, and interactions with
                  these ad impressions and ad services are related to visits to
                  our Website. Google’s use of the DoubleClick cookie enables it
                  and its partners to serve ads based on your visit to our
                  Website and/or other sites and online services. To learn more
                  about how to opt out of Google’s use of first-party cookies,
                  click here. To learn more about how to opt out of
                  DoubleClick’s use of cookies, visit the DoubleClick opt-out
                  page, here.
                </p>
              </li>
              <li>
                <b>Do Not Track Signals</b>
                <p className="subpage__paragraph">
                  Some web browsers are developing or offering signals or other
                  mechanisms for the expression of consumer choice regarding the
                  collection of information about an individual consumer’s
                  online activities over time and across third-party web sites
                  or online services (e.g., a “Do Not Track” (“DNT”) signal). A
                  DNT signal is a HTTP header field indicating your preference
                  regarding tracking or cross-site user tracking. We do not
                  monitor or take any action with respect to DNT signals.
                </p>
              </li>
              <li>
                <b>Ads and Information About You</b>
                <p className="subpage__paragraph">
                  We may work with third parties, such as network advertisers
                  and ad exchanges that use tracking technologies on our Website
                  in order to provide tailored advertisements on our behalf
                  and/or on behalf of other advertisers across the Internet and
                  we may use third party analytics service providers to evaluate
                  and provide us and/or third parties with information about the
                  use of these ads on third party sites and viewing of ads and
                  of our content. Network advertisers are third parties that
                  display advertisements, which may be based on your activities
                  (including past visits to our Website) across the Internet and
                  mobile media (“Behavioral Ads”). Behavioral Ads enable us to
                  target advertisements to you for products and services in
                  which we believe you might be interested. If you object to
                  receiving Behavioral Ads from us on third party sites, you can
                  learn more about your ability to limit Behavioral Ads below.
                  Our third party ad network and exchange providers, the
                  advertisers and/or traffic measurement services may themselves
                  set and access their own technologies on your device and track
                  certain behavioral usage information via a device identifier.
                  These third party technologies may be set to, among other
                  things: (a) help deliver advertisements to you that you might
                  be interested in; (b) prevent you from seeing the same
                  advertisements; and (c) understand the usefulness of the
                  advertisements that have been delivered to you.
                </p>
                <br></br>
                <p className="subpage__paragraph">
                  Statements regarding our practices do not apply to the methods
                  for collecting information used by these third parties or the
                  use of the information that such third parties collect. We do
                  however work with third parties to make efforts to have you
                  provided with information on their practices and any available
                  opportunity to exercise choice. We make no representations
                  regarding the policies or practices of third party advertisers
                  or advertising networks or exchanges or related third parties.
                </p>
              </li>
              <li>
                <b>External Links</b>
                <p className="subpage__paragraph">
                  The Website may offer links to and from other third party
                  sites. Other sites have their own policies regarding privacy.
                  If you visit one of these sites, you may want to review the
                  privacy policy on that site. For example, you may have linked
                  to the Company’s brand site through a banner advertisement on
                  another site. In such cases the site you have linked from may
                  collect information from people who click on the banner or
                  link. You may want to refer to the privacy policies on those
                  sites to see how they collect and use this information.
                </p>
              </li>
              <li>
                <b>Social Media Widgets</b>
                <p className="subpage__paragraph">
                  The Website may include social media features (“Features”),
                  such as the Facebook Like button, and widgets, such as the
                  Share This button or interactive applications or mini-programs
                  that run on our Website. These Features may collect your
                  Internet protocol address, which page you are visiting on our
                  Website, and may set a cookie to enable the Feature to
                  function properly. The use of this functionality may involve
                  the third-party operator providing certain information,
                  including Personal Information, to us. If you click on social
                  media icons on the Website (such as for Facebook, Twitter or
                  Instagram), those actions may be associated with, and we may
                  have access to, your Personal Information you provided on
                  those third-party sites or applications. If so, we will then
                  treat it as Personal Information under this Privacy Policy,
                  since we are collecting it as a result of your accessing of
                  and interaction on our Website. Features are either hosted by
                  a third party or hosted directly on our Website. Your
                  interactions with these Features are governed by the privacy
                  statement of the company providing it. You should review the
                  applicable third-party privacy policies before using such
                  third-party tools on our Website.
                </p>
              </li>
              <li>
                <b>Blogs/Forums</b>
                <p className="subpage__paragraph">
                  Our Website may, from time to time, offer publicly accessible
                  blogs or community forums where you can submit ideas,
                  photographs, writings, music, video, audio recordings,
                  computer graphics, pictures, data, information about your
                  location, questions, comments, suggestions or other content,
                  including personal information. You should be aware that any
                  information you provide in these areas may be read, collected,
                  and used by others who access them. Please note that Company
                  does not control who will have access to the information that
                  you choose to make public, and cannot ensure that parties who
                  have access to such publicly available information will
                  respect your privacy or keep it secure. To request removal of
                  your personal information from our blog or community forum,
                  contact us at info@buyontrust.com. In some cases, we may not
                  be able to remove your personal information, in which case we
                  will let you know if we are unable to do so and why. We are
                  not responsible for the privacy or security of any information
                  that you make publicly available on the Website or what others
                  do with information you share with them on the Website. We are
                  not responsible for the accuracy, use or misuse of any user
                  content that you disclose or receive from third parties
                  through the Website.
                </p>
              </li>
              <li>
                <b>International Users</b>
                <p className="subpage__paragraph">
                  Our Website is operated in the United States and intended for
                  users located in the United States. Like almost every website,
                  our Website can be accessed by an international audience. If
                  you are located outside of the United States, please be aware
                  that information we collect, including personal information,
                  will be transferred to, and processed, stored and used in the
                  United States. The data protection laws in the United States
                  may differ from those of the country in which you are located,
                  and your personal information may be subject to access
                  requests from governments, courts, or law enforcement in the
                  United States according to laws of the United States. In
                  addition, such data may be stored on servers located outside
                  your resident jurisdiction and in jurisdictions which may have
                  less stringent privacy practices than your own. By using the
                  Website or providing us with any information, you consent to
                  the transfer to, and processing, usage, sharing and storage of
                  your information, including personal information, in the
                  United States as set forth in this Privacy Policy.
                </p>
              </li>
              <li>
                <b>Your California Privacy Rights</b>
                <p className="subpage__paragraph">
                  California Civil Code Section 1798.83 permits customers of
                  Company who are California residents to request and obtain
                  from us once a year, free of charge, information about the
                  personal information (if any) we disclosed to third parties
                  for the third parties’ direct marketing purposes in the
                  preceding calendar year. If applicable, this information would
                  include a list of the categories of personal information that
                  was shared and the names and addresses of all third parties
                  with which we shared information in the immediately preceding
                  twelve (12) calendar months. If you are a California resident
                  and would like to make such a request, please submit your
                  request in writing to:
                </p>
                <br></br>
                <i>1434 Spruce Street</i>
                <br></br>
                <i>Suite 100,</i>
                <br></br>
                <i>Boulder, CO 80302</i>
              </li>
              <li>
                <b>Notification of Changes</b>
                <p className="subpage__paragraph">
                  We may revise this Privacy Policy from time to time. If we
                  decide to change our Privacy Policy, we will post the revised
                  policy here. If we make any material changes, we will notify
                  you by email (sent to the e-mail address specified in your
                  account) or by means of a notice on this Website prior to the
                  change becoming effective. As we may make changes at any time
                  without notifying you, we suggest that you periodically
                  consult this Privacy Policy. Your continued use of the Website
                  after the changes are posted constitutes your agreement to the
                  changes, both with regard to information we have previously
                  collected from you and with regard to information we collect
                  from you in the future. If you do not agree to the changes,
                  please discontinue your use of our Website.
                </p>
              </li>
              <li>
                <b>Contact Information</b>
                <p className="subpage__paragraph">
                  If you have any questions about the Privacy Policy or
                  practices described in it, you should contact us in the
                  following ways:
                </p>
                <br></br>
                <i>1434 Spruce Street</i>
                <br></br>
                <i>Suite 100,</i>
                <br></br>
                <i>Boulder, CO 80302</i>
                <br></br>
                <br></br>
                <i>
                  Phone:
                  <a
                    href="tel:+18882747732"
                    style={{
                      marginLeft: '4px',
                      color: '#4f4f4f',
                      fontWeight: '600'
                    }}>
                    (888) 274-7732
                  </a>
                </i>
                <br></br>
                <i>
                  Email:
                  <a
                    href="mailto:info@buyontrust.com"
                    style={{
                      marginLeft: '4px',
                      color: '#4f4f4f',
                      fontWeight: '600'
                    }}>
                    info@buyontrust.com
                  </a>
                </i>
              </li>
            </ol>
            <br></br>
            <p className='subpage__paragraph last-update note'>Last updated August 6, 2024</p>
            <br></br>
            <i className="subpage__paragraph note center">
              *This estimated payment is only an estimate. Not all applicants
              are approved or qualify for these terms. Actual terms will be in
              the lease agreement. Not available in MN, NJ, WI & WY.
            </i>
          </div>
        </div>
      </div>
    </main>
    </>
  );
}
